import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@glu/dropdown-react';
import LocaleContext from '../../../locale';

export const DelimitedDropdownComponent = ({ dataQa, name, options, ...props }) => {
  const locale = useContext(LocaleContext);

  return (
    <Dropdown
      dataQa={dataQa}
      defaultSelectMessage={locale['common.select']}
      filterEnabled={false}
      forcePositionY
      htmlId={dataQa}
      name={name}
      options={options}
      placeholder={locale['common.select']}
      {...props}
    />
  );
};

DelimitedDropdownComponent.propTypes = {
  dataQa: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

DelimitedDropdownComponent.defaultProps = {
  dataQa: 'map-delimited'
};

export default DelimitedDropdownComponent;
